import React from 'react';
import { required, SelectInput } from 'react-admin';

export const REGION_OPTIONS = [
  { id: 'Upper Valley VT/NH', name: 'Upper Valley VT/NH' },
  { id: 'Southern NH', name: 'Southern NH' },
  { id: 'Greater Boston', name: 'Greater Boston' },
  { id: 'Rhode Island', name: 'Rhode Island' },
  { id: 'New Hampshire', name: 'New Hampshire' },
  { id: 'Massachusetts', name: 'Massachusetts' },
  { id: 'Texas', name: 'Texas' },
];

export const RegionInput = (isRequired) => (
  <SelectInput
    validate={isRequired ? [required()] : []}
    source="region"
    choices={REGION_OPTIONS}
  />
);
